export default __webpack_public_path__ + "static/media/menu.bec214ad.svg";